import { ToggleField } from '.'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const LabeledToggleField = LabelFieldFactory({ InputComponent: ToggleField })
export { LabeledToggleField }
